import React from 'react';

export const acceptanceCashReturnConfig = [
  {
    path: '/acceptance',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/acceptance/add',
    component: React.lazy(() => import('./add/add')),
  },
  {
    path: '/acceptance/view',
    component: React.lazy(() => import('./view/view')),
  },
];
